import { useState } from 'react';
import { queryStringUtils } from 'shared/utils/query_string_utils';

const defaultOptions = { arrayFormat: 'bracket', parseNumbers: true, parseBooleans: true };

export function useQueryParam(name, defaultValue, options = {}) {
  options = { ...defaultOptions, ...options };
  const queryParam = queryStringUtils.getQueryParam(name, options) || defaultValue;

  const [param, setParam] = useState(queryParam);

  function setQueryParam(value, replaceState = false) {
    setParam(value);
    const queryParams = queryStringUtils.getQueryParams();

    if (value === null) {
      delete queryParams[name];
    } else {
      queryParams[name] = value;
    }

    const newUrl = `${queryStringUtils.baseUrl()}?${queryStringUtils.buildParams(queryParams, options)}`;

    if (replaceState) {
      window.history.replaceState(null, null, newUrl);
    } else {
      window.history.pushState(null, null, newUrl);
    }
  }

  return [param, setQueryParam];
}
